function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1052:578)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.3332 7.99336L13.7065 6.13336L13.9332 3.67336L11.5265 3.1267L10.2665 1.00003L7.99984 1.97336L5.73317 1.00003L4.47317 3.1267L2.0665 3.6667L2.29317 6.13336L0.666504 7.99336L2.29317 9.85336L2.0665 12.32L4.47317 12.8667L5.73317 15L7.99984 14.02L10.2665 14.9934L11.5265 12.8667L13.9332 12.32L13.7065 9.86003L15.3332 7.99336ZM12.6998 8.98003L12.3265 9.41336L12.3798 9.98003L12.4998 11.28L11.2332 11.5667L10.6732 11.6934L10.3798 12.1867L9.71984 13.3067L8.53317 12.7934L7.99984 12.5667L7.47317 12.7934L6.2865 13.3067L5.6265 12.1934L5.33317 11.7L4.77317 11.5734L3.5065 11.2867L3.6265 9.98003L3.67984 9.41336L3.3065 8.98003L2.4465 8.00003L3.3065 7.01336L3.67984 6.58003L3.61984 6.0067L3.49984 4.71336L4.7665 4.4267L5.3265 4.30003L5.61984 3.8067L6.27984 2.6867L7.4665 3.20003L7.99984 3.4267L8.5265 3.20003L9.71317 2.6867L10.3732 3.8067L10.6665 4.30003L11.2265 4.4267L12.4932 4.71336L12.3732 6.01336L12.3198 6.58003L12.6932 7.01336L13.5532 7.99336L12.6998 8.98003Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.7262 9.1667L5.17954 7.61337L4.19287 8.6067L6.7262 11.1467L11.6195 6.24004L10.6329 5.2467L6.7262 9.1667Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1052:578"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

var SvgVerified = function SvgVerified(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVerified, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/verified.3c3dd2b2.svg";
export { ForwardRef as ReactComponent };